export default __webpack_public_path__ + "static/dairy-free-health-1-desktop-46603b6dc53761dd3f478f8c6787f85b.png";